module.exports = __webpack_public_path__ + "img/alert-circle-outline.ef60ae30.svg";